import React from "react";
import CountUp from "react-countup";
import useSettings from "../../hooks/useSettings";

import "./style.css";

const About = () => {
  const { settings } = useSettings();
  const bg = "/img/about_background_1.webp";
  const img1 = "/img/about-1-1_1.webp";
  const img2 = "/img/about-2-2_1.webp";

  return (
    <section className="about-area" style={{ backgroundImage: `url(${bg})` }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6">
            <div className="about-left" data-aos="fade-right">
              <div className="site-heading">
                <h3 className="sub-title">ABOUT US</h3>
                <h2 className="section-title">
                  Partner with {settings?.companyName || "Al-Hady"}
                </h2>
              </div>
              <p>
                {settings?.aboutDescription || 
                  "Digitize your building & construction workflow and be More Profitable in your Projects with a Trusted and Qualified BIM Partner."}
              </p>

              <div className="about-signature">
                <div className="signature-left cta-btn btn-fill" style={{ cursor: 'pointer' }}>
                  <a
                    href="/El Hady Office Brochure.pdf"
                    download
                    style={{ cursor: 'pointer', textDecoration: 'none' }}
                  >
                    Download Brochure
                  </a>

                </div>

              </div>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1 col-md-6">
            <div className="about-counter">
              <div className="counter-box">
                <h2>
                  <span className="counter">
                    <CountUp start={0} end={settings?.yearsExperience || 15} duration={1} />
                  </span>
                  +
                </h2>
                <p>
                  Years of <br />
                  experience
                </p>
              </div>
              <div className="counter-box">
                <h2>
                  <span className="counter">
                    <CountUp start={0} end={settings?.projectsCompleted || 187} duration={2} />
                  </span>
                  +
                </h2>
                <p>
                  Projects <br />
                  Completed
                </p>
              </div>

            </div>
            <div className="about-right" data-aos="fade-left">
              <img className="about_img_1" src={img2} alt="img" />
              <img className="about_img_2" src={img1} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(About);
